import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as constants from '../constants'
import type { Plugin } from '../plugin'

/**
 * Loads joint-use data when the organization draft under the plugin-owned
 * current-entity target changes.
 */
export const loadForCurrentEntityOnEditedEntityChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.currentEntityPlugin.feature.selectors
      .getLatestEntity({ target: constants.CURRENT_ENTITY_TARGET })
      .asObservable.pipe(
        rxjs.distinctUntilChanged(isDeepEqual),
        rxjs.filter(TypeChecker.isNotNullish.raw),
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from('loadForCurrentEntityOnEditedEntityChange (effect)')
            .create(),
        ),
      ),
)
